import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useJsApiLoader } from '@react-google-maps/api';
import { Typewriter } from 'react-simple-typewriter';
import Footer from '../components/Footer';
import './AddressPage.css';

const AddressPage = () => {
  // Define state variables
  const [address, setAddress] = useState('');
  const [isOver18, setIsOver18] = useState(true); // Track checkbox state
  
  // Define hooks
  const navigate = useNavigate();
  const inputRef = useRef(null);

  // Setup Google Maps API
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: ['places'],
  });

  // Setup autocomplete when the API is loaded
  useEffect(() => {
    if (!isLoaded) return;

    const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
      types: ['geocode'],
    });

    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      if (place?.formatted_address) {
        setAddress(place.formatted_address);
        localStorage.setItem('userAddress', place.formatted_address);
        navigate('/nearby');
      }
    });
  }, [isLoaded, navigate]);

  // Error handling for Google Maps API
  if (loadError) {
    return <p>Error loading Google Maps API</p>;
  }

  if (!isLoaded) {
    return <p>Loading...</p>;
  }

  return (
    <div className="address-page-container">
      <div className="address-logo-container">
        <img
          src={require('../assets/images/addressPageLogo.png')}
          alt="WeedHurry Logo"
          className="logo"
        />
        
        {/* Courier Button in upper right corner */}
        <button 
          className="courier-button"
          onClick={() => navigate('/courier')}
        >
          Courier
        </button>
      </div>

      {/* Middle Section */}
      <div className="content-container">
        {/* Animated Heading */}
        <h3 className="page-heading">
          <Typewriter
            words={['Free delivery nearest you']}
            loop={1}
            cursor={false}
            typeSpeed={40}
            deleteSpeed={30}
            delaySpeed={1000}
          />
        </h3>

        {/* Address Input Field */}
        <div className="address-input-wrapper">
          <input
            type="text"
            ref={inputRef}
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            placeholder="Enter your address"
            className="address-input"
            disabled={!isOver18}
          />
        </div>

        {/* Checkbox for Age Confirmation */}
        <div className="age-checkbox-container">
          <input
            type="checkbox"
            className="age-checkbox"
            id="ageCheck"
            checked={isOver18}
            onChange={(e) => setIsOver18(e.target.checked)}
          />
          <label className="age-label" htmlFor="ageCheck">
            I am 21 or older
          </label>
        </div>
      </div>
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default AddressPage;